import { render, staticRenderFns } from "./FilteredList.vue?vue&type=template&id=0b1fbba8&scoped=true"
import script from "./FilteredList.vue?vue&type=script&lang=js"
export * from "./FilteredList.vue?vue&type=script&lang=js"
import style0 from "./FilteredList.vue?vue&type=style&index=0&id=0b1fbba8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b1fbba8",
  null
  
)

export default component.exports